import Global from "./Global";

class Api {

    isProduction = process.env.NODE_ENV === "production";
    appMode = process.env.REACT_APP_MODE ?? "PRODUCTION";

    isConsoleEnabled = false;
    // apiUrl = "http://localhost:8000/api/";
    // baseImageFolder = "http://localhost:8000/images/";
    // baseDocsFolder = "http://localhost:8000/docs/";
    // baseVideosFolder = "http://localhost:8000/videos/";
    // baseAudiosFolder = "http://localhost:8000/audios/";
    // socketUrl = "http://localhost:4002/";
    // lavenderUrl = "https://lavender.prestisa.id/";
    // lotusUrl = "http://localhost:3000";

    apiUrl = process.env.REACT_APP_API_URL;
    apiUrlNew = process.env.REACT_APP_API_URL_NEW;
    s3BaseUrl = process.env.REACT_APP_S3_BASE_URL;
    s3Bucket = process.env.REACT_APP_S3_BUCKET;
    baseImageFolder = process.env.REACT_APP_BASE_IMAGE_FOLDER;
    baseDocsFolder = process.env.REACT_APP_BASE_DOCS_FOLDER;
    baseVideosFolder = process.env.REACT_APP_BASE_VIDEOS_FOLDER;
    baseAudiosFolder = process.env.REACT_APP_BASE_AUDIOS_FOLDER;
    // socketUrlProduction = "https://34.126.168.205:4002/";
    socketUrl = process.env.REACT_APP_SOCKET_URL;
    lavenderUrl = process.env.REACT_APP_LAVENDER_URL;
    lotusUrl = process.env.REACT_APP_LOTUS_URL;
    aiSuggestionUrl = process.env.REACT_APP_AI_SUGGESTION_URL;


    // apiUrlProduction = "http://34.101.255.51/api/";
    // baseImageFolderProduction = "http://34.101.255.51/images/";
    // baseDocsFolderProduction = "http://34.101.255.51/docs/";
    // socketUrlProduction = "http://34.101.255.51:4001/";

    // apiUrlProduction = process.env.REACT_APP_API_URL;
    // baseImageFolderProduction = process.env.REACT_APP_BASE_IMAGE_FOLDER;
    // baseDocsFolderProduction = process.env.REACT_APP_BASE_DOCS_FOLDER;
    // baseVideosFolderProduction = process.env.REACT_APP_BASE_VIDEOS_FOLDER;
    // baseAudiosFolderProduction = process.env.REACT_APP_BASE_AUDIOS_FOLDER;
    // // socketUrlProduction = "https://34.126.168.205:4002/";
    // socketUrlProduction = process.env.REACT_APP_SOCKET_URL;
    // lavenderUrlProduction = process.env.REACT_APP_LAVENDER_URL;
    // lotusUrlProduction = process.env.REACT_APP_LOTUS_URL;
    // apiUrlProduction = "https://lotus.prestisa.id/lavenger-backend/public/api/";
    // baseImageFolderProduction = "https://lotus.prestisa.id/lavenger-backend/public/images/";
    // baseDocsFolderProduction = "https://lotus.prestisa.id/lavenger-backend/public/docs/";
    // baseVideosFolderProduction = "https://lotus.prestisa.id/lavenger-backend/public/videos/";
    // baseAudiosFolderProduction = "https://lotus.prestisa.id/lavenger-backend/public/audios/";
    // // socketUrlProduction = "https://34.126.168.205:4002/";
    // socketUrlProduction = "https://testlotus.prestisa.id:4002/";
    // lavenderUrlProduction = "https://lavender.prestisa.id/";
    // lotusUrlProduction = "https://lotus.prestisa.id/";

    // eslint-disable-next-line no-useless-constructor
    constructor() { }

    getRequestHeader() {
        return {
            headers: {
                "Content-Type": `application/x-www-form-urlencoded`,
                Accept: `application/json`,
                // "Authorization": `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIzIiwianRpIjoiNzYzMWM2ZDcyNjFkNzZjNDFiNzllOTcwN2VhOTEwZmVmZmZlYzNkZjZkNTFlZWE4OTc0NzkyN2ExOGQ5ZmM0YWNkYmM4ZDdkZTJmOTViMmQiLCJpYXQiOjE2MTc4NjMxNjAsIm5iZiI6MTYxNzg2MzE2MCwiZXhwIjoxNjQ5Mzk5MTYwLCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.PCWEbaXWX0_GL7SQlKYjKhB34Jhbd3QZYZ1s9RyOka2_1-3e10x8VXB_76Nj7QGc01MyL0pDVzydauQfk9pZoI3DgP64nkPZzHSwKv1Ravl6nO6QCjDzF0ZGiA6fYf-VyiRkRgSbporDTqB5nwxtDYNYWEYzCB8rLAP5q2mmyJoneaT6fbnVbEKOewTpx3wbHdFfxH-rzdZgfR8r6u1H91-OZztVac71N8u0YQfO1Tyz1Y9MxvHJS7mAJCP36dj2ZIyyY4KP5XBnT-1avDwJHv19s5uTlMi4wdKwJkuIslbp5oUzWblS6m6yO46hjyQT5ewUa31FkbHDa_C4co1ZF1muj2mN13NuW0T6nyRCTqITEiAE6d2V3_UNSlJqhiFGmwseE4U9ONkzISPqvob-Z6PdKs3UdBUwkmWT02lBUZkXFf_kjObisTP4gDKKr7qsJMx3-9M4r7i3MGJm_AV1VB7xaRbhpZMykBvZOPTd6piacwBbzTM3S2YTrTbF_cLVzUvAs3EYQ1NivSj8q5NzUJfZWqiuCE0fUvR9vwZ5VhytbmSenHCKO_dpoHOqmtoeSEw1sU-Mno6sxlEmpdPi641VFpK0394fw596f71pLCrtuXEjsnDnxbIKG5by1vTHMSwfg9sogErLWXej5kuMs6WTj_1zzajdg21FfxDvAWI`,
                Authorization: "Bearer " + Global.get().access_token,
            },
        };
    }

    getRequestHeaderJson() {
        return {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + Global.get().access_token,
            },
        };
    }

    getRequestHeaderJsonNew() {
        return {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + Global.get().be_express_token,
                // "Authorization": "Bearer I6Im9wY2hhdWxhQHByZXN0aXNhLmNvbSIsIm5hbWUiOiJvcCBjaGF1bGEiLCJyb2xlIjoiaXQtZGF0YWJhc2UiLCJpYXQiOjE3ODI2MzgxNTYsImV4cCI6MTgxNDE3NDE1Nn0.bRvVl-6UPfUtJxxDgLCubv2TVm58EDSPFL-E_Dld5H4",
            },
        };
    }

    getRequestHeaderNoAuth() {
        return {
            headers: {
                "Content-Type": `application/x-www-form-urlencoded`,
                Accept: `application/json`,
                // "Authorization": `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiMTc2YjUyN2FiMGNiMGNlOTUwZGQ2OWYxZWJkOWRmMDU0NGVjYTE4MTQ3MDg0OWY0YmRlZmUxMDkzYjRmNGJiNTcyYzQ0ZDE4Zjk5MWU3ZDIiLCJpYXQiOjE2MDk3Mjc1MDAsIm5iZiI6MTYwOTcyNzUwMCwiZXhwIjoxNjQxMjYzNTAwLCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.vaBxznomz3Z5_HpiRZ5J_Z3PNeKj57APwx_w66IorcmJVI_bVD1gBodFM_nhX6p6LdSJmkX1Eah64WIBJJiZ__emsN54XLt59BHHvOpSSoYfRKM0NHrpjlXCNzoDaiEY6BVwr74_9rVlR615G5qa_7azUeT2oSiTwUtXWdRUkDDJSq9SxkO_cXms4Zes3WZKSAQmv1NOCUxlbU0NX8Vt3y8bo4oE-eaGktKHua8iyvpABrYITyVmfFJRSu0owe5KzB560oFGLIxJ6ipR3jRO59U-R3mmV7-twIc1mVXY6B96rsyRZX6NFrUAEVyVByGbsjV4Jx4qr3ABN0GzUgLi5HxFS7PvMTTTlYBuB0GEBx5uBFWiH5T1nQLfAmpxSMF0050nyDRk1xH8HNARU3MoadsYwCD6N-81IOz9mm6hh8gXo-d8ZUJdGxi1Iegsh4xPV4ntvEf2CGjBFFZk-GYzgX4yfcilR3Q7pS5N56rukSkBFiipuPRjgtCwXoGZeHB1udWTIyNXLOIcwAR6k27KOP1kvBGy0AMcnxTYJK08VaZGQh6BnrXw3hw_n0GXXFVe0gPUO4IxrHFy0vyuWAFg4xOKdJT0bWykigikvFQM8nkOKvJTZjsbulAyeZo-XGr8FNFeO1WtE0QP7zyd5h6wzuLW7pr_-zc8hAvmJyw-Dbs`,
                // "Authorization": 'Bearer ' + Global.get().access_token,
            },
        };
    }

    getRequestHeaderNoAuthNew() {
        return {
            headers: {
                "Content-Type": `application/json`,
                Accept: `application/json`,
                // "Authorization": `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiMTc2YjUyN2FiMGNiMGNlOTUwZGQ2OWYxZWJkOWRmMDU0NGVjYTE4MTQ3MDg0OWY0YmRlZmUxMDkzYjRmNGJiNTcyYzQ0ZDE4Zjk5MWU3ZDIiLCJpYXQiOjE2MDk3Mjc1MDAsIm5iZiI6MTYwOTcyNzUwMCwiZXhwIjoxNjQxMjYzNTAwLCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.vaBxznomz3Z5_HpiRZ5J_Z3PNeKj57APwx_w66IorcmJVI_bVD1gBodFM_nhX6p6LdSJmkX1Eah64WIBJJiZ__emsN54XLt59BHHvOpSSoYfRKM0NHrpjlXCNzoDaiEY6BVwr74_9rVlR615G5qa_7azUeT2oSiTwUtXWdRUkDDJSq9SxkO_cXms4Zes3WZKSAQmv1NOCUxlbU0NX8Vt3y8bo4oE-eaGktKHua8iyvpABrYITyVmfFJRSu0owe5KzB560oFGLIxJ6ipR3jRO59U-R3mmV7-twIc1mVXY6B96rsyRZX6NFrUAEVyVByGbsjV4Jx4qr3ABN0GzUgLi5HxFS7PvMTTTlYBuB0GEBx5uBFWiH5T1nQLfAmpxSMF0050nyDRk1xH8HNARU3MoadsYwCD6N-81IOz9mm6hh8gXo-d8ZUJdGxi1Iegsh4xPV4ntvEf2CGjBFFZk-GYzgX4yfcilR3Q7pS5N56rukSkBFiipuPRjgtCwXoGZeHB1udWTIyNXLOIcwAR6k27KOP1kvBGy0AMcnxTYJK08VaZGQh6BnrXw3hw_n0GXXFVe0gPUO4IxrHFy0vyuWAFg4xOKdJT0bWykigikvFQM8nkOKvJTZjsbulAyeZo-XGr8FNFeO1WtE0QP7zyd5h6wzuLW7pr_-zc8hAvmJyw-Dbs`,
                // "Authorization": 'Bearer ' + Global.get().access_token,
            },
        };
    }

    getRequestHeaderEmpty() {
        return {
            headers: {},
        };
    }

    setConsoleEnabled(value) {
        this.isConsoleEnabled = value;
    }

    getApiUrl() {
        return this.apiUrl;
    }

    getApiUrlNew() {
        return this.apiUrlNew;
    }

    getS3Url() {
        return `${this.s3BaseUrl}${this.s3Bucket}` ;
    }

    getLavenderUrl() {
        return this.lavenderUrl;
    }

    getLotusUrl() {
        return this.lotusUrl;
    }

    getAiSuggestionUrl() {
        return this.aiSuggestionUrl;
    }

    getSocketUrl() {
        return this.socketUrl;
    }

    getBaseImageUrl() {
        return this.baseImageFolder;
    }

    getBaseDocsUrl() {
        return this.baseDocsFolder;
    }

    getBaseVideosUrl() {
        return this.baseVideosFolder;
    }

    getBaseAudiosUrl() {
        return this.baseAudiosFolder;
    }

    logout() {
        return this.getApiUrl() + "logout";
    }

    // ==================================================================
    // CS Ticketing (PRD v1.3.0) — authenticated endpoints
    // ==================================================================

    csTicketQueue(params = {}) {
        const qs = new URLSearchParams();
        ['status', 'category', 'date', 'q', 'page', 'per_page'].forEach((k) => {
            if (params[k] !== undefined && params[k] !== null && params[k] !== '') {
                qs.append(k, params[k]);
            }
        });
        const query = qs.toString();
        return this.getApiUrl() + "cs/ticket/queue" + (query ? `?${query}` : "");
    }

    /**
     * Queue endpoint khusus untuk modal "Antrian Customer CS" di sidebar CS.
     * Smart: return 1-ticket mode kalau CS sedang handle, else full queue.
     */
    csTicketQueueForAgent() {
        return this.getApiUrl() + "cs/ticket/queue-for-agent";
    }

    csTicketTake(id) {
        return this.getApiUrl() + "cs/ticket/" + encodeURIComponent(id) + "/take";
    }

    csTicketClose(id) {
        return this.getApiUrl() + "cs/ticket/" + encodeURIComponent(id) + "/close";
    }

    csTicketAddNote(id) {
        return this.getApiUrl() + "cs/ticket/" + encodeURIComponent(id) + "/notes";
    }

    csTicketSetCoIssue(id) {
        return this.getApiUrl() + "cs/ticket/" + encodeURIComponent(id) + "/co-issue";
    }

    /**
     * Customer Profile panel data (PRD v1.3.0 gambar ke-5):
     * join CsTicket + Order + OrderItems untuk tampilan side panel di chat room.
     */
    csTicketCustomerProfile(waNumber) {
        return this.getApiUrl() + "cs/ticket/customer-profile/" + encodeURIComponent(waNumber);
    }

    csReportSummary(params = {}) {
        const qs = new URLSearchParams();
        ['from', 'to'].forEach((k) => {
            if (params[k]) qs.append(k, params[k]);
        });
        const query = qs.toString();
        return this.getApiUrl() + "cs/report/summary" + (query ? `?${query}` : "");
    }

    csReportAgentPerformance(params = {}) {
        const qs = new URLSearchParams();
        ['from', 'to'].forEach((k) => {
            if (params[k]) qs.append(k, params[k]);
        });
        const query = qs.toString();
        return this.getApiUrl() + "cs/report/agent-performance" + (query ? `?${query}` : "");
    }

    // Ticket settings (list / update bulk)
    csTicketListSettings() {
        return this.getApiUrl() + "cs/ticket/settings";
    }

    csTicketUpdateSettings() {
        return this.getApiUrl() + "cs/ticket/settings";
    }

    // Auto-reply templates CRUD
    csAutoReplyList() {
        return this.getApiUrl() + "cs/auto-reply";
    }

    csAutoReplyCreate() {
        return this.getApiUrl() + "cs/auto-reply";
    }

    csAutoReplyUpdate(id) {
        return this.getApiUrl() + "cs/auto-reply/" + encodeURIComponent(id);
    }

    csAutoReplyDelete(id) {
        return this.getApiUrl() + "cs/auto-reply/" + encodeURIComponent(id);
    }

    doSaveSales() {
        return this.getApiUrl() + "save-sales";
    }

    resendMessage() {
        return this.getApiUrl() + "resend-message";
    }

    contactCancelListPagedSearchable() {
        return this.getApiUrl() + "contact-cancel-list-paged-searchable";
    }

    historyPerubahanLabelByLeads() {
        return this.getApiUrl() + "resume-history-label-by-leads";
    }

    resumeContactCancelByKategoriProblemMonthly() {
        return this.getApiUrl() + "resume-contact-cancel-by-kategori-monthly";
    }

    resumeContactCancelByPermasalahanMonthly() {
        return this.getApiUrl() + "resume-contact-cancel-by-permasalahan-monthly";
    }

    getListJustReadMessage() {
        return this.getApiUrl() + "list-just-read-message";
    }

    getListHsmImages(type) {
        return this.getLavenderUrl() + "api/tele/dev/06fb3bbd09b99c8db8386c22efa6aba0/imagehsm/getall?tipe=" + type;
    }

    getDataPendingReportFu() {
        return this.getApiUrl() + "data-pending-fu-report";
    }

    getLeadsReportSummary() {
        return this.getApiUrl() + "leads-report-summary";
    }

    getCityList() {
        return this.getApiUrl() + "city-list";
    }

    listRunningCheckpoint() {
        return this.getApiUrl() + "list-running-checkpoint";
    }

    updateCheckpoint() {
        return this.getApiUrl() + "update-checkpoint";
    }

    checkPointReport() {
        return this.getApiUrl() + "check-point-report";
    }

    datapendingPivotTable() {
        return this.getApiUrl() + "data-pending-pivot-table";
    }

    autoHandoverEventReminderCustomer() {
        return this.getApiUrl() + "auto-handover-event-reminder-customer";
    }

    dailyClosingRateReport() {
        return this.getApiUrl() + "daily-closing-rate-report";
    }

    listCustomerWajibBayar() {
        return this.getApiUrl() + "list-customer-wajib-bayar";
    }

    listChatNggantung() {
        return this.getApiUrl() + "list-chat-nggantung";
    }

    teleResponseTimeReport() {
        return this.getApiUrl() + "tele-response-time-reports";
    }

    usersBySlugRole() {
        return this.getApiUrl() + "users-by-slug-role";
    }

    verifySession() {
        return this.getApiUrl() + "verify-session";
    }

    checkpointUserList() {
        return this.getApiUrl() + "checkpoint-user-list";
    }

    saveCheckpointUser() {
        return this.getApiUrl() + "save-checkpoint-user";
    }

    deleteCheckpointUser() {
        return this.getApiUrl() + "delete-checkpoint-user";
    }

    saveCustomerName() {
        return this.getApiUrl() + "save-customer-name";
    }

    dataCancelResponseTimeReport() {
        return this.getApiUrl() + "data-cancel-response-time-reports";
    }

    historyContactLabel() {
        return this.getApiUrl() + "history-contact-label";
    }

    riwayatPerpindahanContact() {
        return this.getApiUrl() + "monitoring-riwayat-perpindahan-contact";
    }

    getDataPendingLeads() {
        return this.getApiUrl() + "data-pending-leads-reports";
    }

    getDataPendingLeadsParcel() {
        return this.getApiUrl() + "data-pending-leads-parcel-reports";
    }

    getLeadsBelumAdaLabel() {
        return this.getApiUrl() + "leads-belum-ada-label";
    }

    getListDailyFu() {
        return this.getApiUrl() + "list-fu-tele-daily";
    }

    allContactBerlabelCancel() {
        return this.getApiUrl() + "all-contact-berlabel-cancel";
    }

    kedisiplinanFuTele = () => {
        return this.getApiUrl() + "kedisiplinan-fu-tele";
    }

    leadsParcel = () => {
        return this.getApiUrl() + "leads-parcel";
    }

    dataSampah = () => {
        return this.getApiUrl() + "data-sampah";
    }

    dataRiset = () => {
        return this.getApiUrl() + "data-riset";
    }

    inobundByReferral = () => {
        return this.getApiUrl() + "inbound-by-referral";
    }

    listAnalisaDataCancel = () => {
        return this.getApiUrl() + "list-analisa-data-cancel";
    }

    weeklyCancelLeadsPercentage = () => {
        return this.getApiUrl() + "weekly-cancel-leads-percentage";
    }

    summaryDatabaseDataCancel = () => {
        return this.getApiUrl() + "summary-database-data-cancel";
    }

    allDataCancelByUser = () => {
        return this.getApiUrl() + "all-data-cancel-by-user";
    }

    performaClosingAfterFuDataCancel = () => {
        return this.getApiUrl() + "data-cancel-performa-closing-after-fu";
    }

    listCountry = () => {
        return this.getLavenderUrl() + "api/geo/countries";
    }

    listProvince = (countryId) => {
        return this.getLavenderUrl() + "api/geo/children/" + countryId;
    }

    listCity = (countryId) => {
        return this.getLavenderUrl() + "api/geo/children/" + countryId;
    }

    listProduct = (keyword, page) => {
        return this.getLavenderUrl() + "api/service/0efade19437fb381e3526380bc53659c/orders/search-product?s=" + keyword + "&page=" + page;
    }

    lavenderUploadImage = (keyword, page) => {
        return this.getLavenderUrl() + "api/service/0efade19437fb381e3526380bc53659c/orders/upload-custom-image";
    }

    lavenderGetCustomerInfo = (email, phone) => {
        return this.getLavenderUrl() + "api/service/0efade19437fb381e3526380bc53659c/search-customer?email=" + email + "&phone=" + phone;
    }

    lavenderGetCustomerQna = (phone) => {
        return this.getLavenderUrl() + "api/service/0efade19437fb381e3526380bc53659c/profile-customer?phone=" + phone;
    }

    lavenderSubmitCustomerProfile = () => {
        return this.getLavenderUrl() + "api/service/0efade19437fb381e3526380bc53659c/customer-profile/create";
    }

    loginMonitoring = () => {
        return this.getApiUrl() + "login-monitoring";
    }

    autoleadsHistory = () => {
        return this.getApiUrl() + "autoleads-history";
    }

    hsmFuList = () => {
        return this.getApiUrl() + "hsm-fu-list";
    }

    saveHsmFu = () => {
        return this.getApiUrl() + "save-hsm-fu";
    }

    deleteHsmFu = () => {
        return this.getApiUrl() + "delete-hsm-fu";
    }

    listLeadsCrossedPendingBelumTeralihkan = () => {
        return this.getApiUrl() + "list-leads-crossed-pending-belum-teralihkan";
    }

    listSalesYangOnline = () => {
        return this.getApiUrl() + "list-online-sales";
    }

    doCrossedPendingManually = () => {
        return this.getApiUrl() + "do-crossed-pending-manually";
    }

    hsmMonitoringDaily = () => {
        return this.getApiUrl() + "hsm-monitoring-daily";
    }

    getLatestVersionInfo = () => {
        return this.getApiUrl() + "static/app-version";
    }

    getLavenderOrderByCustomer = () => {
        return this.getApiUrl() + "lavender-order-by-customer";
    }

    getLavenderOrderBySales = () => {
        return this.getApiUrl() + "lavender-order-by-sales";
    }

    getLavenderOrderByCustomerApproved = () => {
        return this.getApiUrl() + "lavender-order-by-customer-approved";
    }

    getLavenderOrderByCustomerAllStatus = () => {
        return this.getApiUrl() + "lavender-order-by-customer-all-status";
    }

    getRegionList = () => {
        return this.getApiUrl() + "region-list";
    }

    getContactNoteList = () => {
        return this.getApiUrl() + "contact/note-list";
    }
    contactNoteSave = () => {
        return this.getApiUrl() + "contact/note-save";
    }
    contactNoteDelete = () => {
        return this.getApiUrl() + "contact/note-delete";
    }
    csResponseTimeReport = () => {
        return this.getApiUrl() + "cs/response-time-report";
    }
    csActiveCustomers = () => {
        return this.getApiUrl() + "cs/active-customers";
    }
    csInQueueCustomers = () => {
        return this.getApiUrl() + "cs/in-queue-customers";
    }
    csInQueueCustomersCount = () => {
        return this.getApiUrl() + "cs/in-queue-customers-count";
    }
    listFu123 = (appProfileId) => {
        return this.getApiUrl() + "sales-online/list-fu123/" + appProfileId;
    }
    isHasCustomerFu = (appProfileId) => {
        return this.getApiUrl() + "sales-online/is-has-customer-fu/" + appProfileId;
    }

    teleChatByCustomer = () => {
        return this.getApiUrl() + "report/tele/customer-leads";
    }

    teleChatByCustomerFiveWhy = () => {
        return this.getApiUrl() + "report/tele/customer-leads/five-why";
    }

    rekomendasiHsm = () => {
        return this.getApiUrl() + "hsm/rekomendasi-hsm";
    }

    saveUsedHsmRekomendasi = () => {
        return this.getApiUrl() + "hsm/save-used-hsm";
    }

    missedLeadsList = () => {
        return this.getApiUrl() + "contact/missed-leads";
    }

    saveHasilFuDataPendingTele = () => {
        return this.getApiUrl() + "tele/data-pending/save-hasil-fu";
    }

    lavenderGetProductCatalogs = (payload) => {
        return this.getLavenderUrl() + `api/service/0efade19437fb381e3526380bc53659c/product-catalog/search?category_id=${payload.categoryId}&city=${payload.cityId}&color=${payload.colorId}&country=${payload.countryId}&flower=${payload.flowerId}&jambul=${payload.jambulId}&name=${payload.name}&province=${payload.provinceId}&sort=&ukuran=${payload.sizeId}`
    }

    lavenderGetAttributes = () => {
        return this.getLavenderUrl() + "api/service/0efade19437fb381e3526380bc53659c/product-catalog/get-attribute"
    }
    lavenderGetProductCategories = () => {
        return this.getLavenderUrl() + "api/service/0efade19437fb381e3526380bc53659c/product-catalog/categories"
    }
    lavenderGetCountries = () => {
        return this.getLavenderUrl() + "api/geo/countries";
    }
    lavenderGetAreaByParent = (parentId) => {
        return this.getLavenderUrl() + `api/geo/children/${parentId}`;
    }
    validateAuth = () => {
        return this.getApiUrl() + "auth/for-lavender-validate";
    }
    teamLeaderList = () => {
        return this.getApiUrl() + "team-leader/list";
    }
    teamLeaderMembers = () => {
        return this.getApiUrl() + "team-leader/members";
    }
    teamLeaderSave = () => {
        return this.getApiUrl() + "team-leader/save";
    }
    teamLeaderDelete = () => {
        return this.getApiUrl() + "team-leader/delete";
    }
    isTeamLeader = () => {
        return this.getApiUrl() + "team-leader/is-leader";
    }
    findTeamByLeader = () => {
        return this.getApiUrl() + "team-leader/find-team-by-leader";
    }
    userBySlugRole = () => {
        return this.getApiUrl() + "user/by-slug-role";
    }
    userBySlugRoles = () => {
        return this.getApiUrl() + "user/by-slug-roles";
    }
    saveFiveWhys = () => {
        return this.getApiUrl() + "tele/five-whys/save";
    }
    teleTrainingList = () => {
        return this.getApiUrl() + "tele/training/list";
    }
    teleTrainingSave = () => {
        return this.getApiUrl() + "tele/training/result-save";
    }

    teleTrainingReport = () => {
        return this.getApiUrl() + "tele/training/report";
    }

    updateWajibBayarStatus = () => {
        return this.getApiUrl() + "contact/update-customer-wajib-bayar";
    }

    teleFuSummary() {
        return this.getApiUrl() + "report/tele/tele-fu-effectivity-rate";
    }

    teleHsmSummary() {
        return this.getApiUrl() + "report/tele/tele-hsm-effectivity-rate";
    }

    checkpointSummary() {
        return this.getApiUrl() + "check-point/summary";
    }

    listActiveAppProfilesByUserId() {
        return this.getApiUrl() + "app-profile/list-active-by-userid";
    }

    getWahaQRCode = () => {
        return this.getApiUrl() + "waha/get-qr-code"
    }

    getPoInfoById = (poId) => {
        return this.getApiUrl() + `po/info-by-id/${poId}`;
    }

    csLeadsReport = () => {
        return this.getApiUrl() + `cs/leads-report`;
    }

    csComplaintCategoriesReport = () => {
        return this.getApiUrl() + `cs/complaint-categories-report`;
    }

    csHelpCategoriesReport = () => {
        return this.getApiUrl() + `cs/help-categories-report`;
    }

    csCustomerSatisfactionReport = () => {
        return this.getApiUrl() + `cs/customer-satisfaction-report`;
    }

    csRevisionNotes = () => {
        return this.getApiUrl() + `cs/revision-notes`;
    }

    customerCancelPendingByFirstLabel = () => {
        return this.getApiUrl() + `customer-cancel-pending-by-first-label`;
    }

    dataCancelPendingList = () => {
        return this.getApiUrl() + `data-cancel/list`;
    }

    savedAnalisaList = () => {
        return this.getApiUrl() + `data-cancel/saved-analisa-list`;
    }

    saveLeadAnalysis = () => {
        return this.getApiUrl() + `data-cancel/save-lead-analysis`;
    }

    saveTicketdataCancel = () => {
        return this.getApiUrl() + `data-cancel/save-ticket`;
    }

    revisiLeadAnalysis = () => {
        return this.getApiUrl() + `data-cancel/revisi-lead-analysis`;
    }

    getAnalisaByPhone = () => {
        return this.getApiUrl() + `data-cancel/analisa-by-phone`;
    }

    getLavenderProductCategories = () => {
        return this.getApiUrl() + `data-cancel/lavender-product-categories`;
    }

    saveCheckpointErrorLog = () => {
        return this.getApiUrl() + `check-point/save-error-log`;
    }

    checkPointUploadImage = () => {
        return this.getApiUrl() + `check-point/upload-image`;
    }

    getRequestHeaderMultipart() {
        return {
            headers: {
                "Content-Type": "multipart/form-data",
                Accept: "application/json",
                Authorization: "Bearer " + Global.get().access_token,
            },
        };
    }

    getGeneralSettings = () => {
        return this.getApiUrl() + `settings/get`;
    }

    getGeneralSettingLogs = () => {
        return this.getApiUrl() + `settings/logs-by-field`;
    }

    updateFuBlastTeleState = () => {
        return this.getApiUrl() + `settings/update/fu-blast-tele-enabled`;
    }

    updateFuBlastTeleAllState = () => {
        return this.getApiUrl() + `settings/update/fu-blast-tele-all-enabled`;
    }

    updateFuBlastTeleRBState = () => {
        return this.getApiUrl() + `settings/update/fu-blast-tele-RB-enabled`;
    }

    updateFuBlastTeleReminderState = () => {
        return this.getApiUrl() + `settings/update/fu-blast-tele-reminder-enabled`;
    }

    updateFuBlastTeleAdmState = () => {
        return this.getApiUrl() + `settings/update/fu-blast-tele-adm-enabled`;
    }

    updateFuBlastTeleDataPendingState = () => {
        return this.getApiUrl() + `settings/update/fu-blast-tele-data-pending-enabled`;
    }

    updateFuBlastTeleDataCancelState = () => {
        return this.getApiUrl() + `settings/update/fu-blast-tele-data-cancel-enabled`;
    }

    updateAutoReplyState = () => {
        return this.getApiUrl() + `settings/update/auto-reply-enabled`;
    }

    updateLeadsPoolingState = () => {
        return this.getApiUrl() + `settings/update/leads-pooling-enabled`;
    }

    getRunningCheckpointByUserByApp = () => {
        return this.getApiUrl() + `check-point/running-by-user-by-app`;
    }

    getTeleLeadsUnLabelled = (appProfileId) => {
        return this.getApiUrl() + `tele/customer-leads/unlabelled-leads/${appProfileId}`;
    }

    getLeadsReportTeamLeader = () => {
        return this.getApiUrl() + `report/tele/by-team-leaders`;
    }

    setLeadProductSales = () => {
        return this.getApiUrl() + `sales-online/set-lead-product`;
    }

    boostPostLeads = () => {
        return this.getApiUrl() + `boostpost-leads`;
    }

    blastSummary = () => {
        return this.getApiUrl() + `monitoring/log-hsm`;
    }

    aiAskSuggestion = () => {
        // return this.getApiUrl() + `ai/ask-respon-suggestions`;
        return this.getAiSuggestionUrl() + `chat-suggestions/ask-response`;
    }

    
    spvCpanelLeadsSummary = () => {
        return this.getApiUrl() + `monitoring/spv-cpanel-leads-summary`;
    }

    spvCpanelClosingRateSummary = () => {
        return this.getApiUrl() + `monitoring/spv-cpanel-closing-rate-summary`;
    }

    spvCpanelFirstResponseSummary = () => {
        return this.getApiUrl() + `monitoring/spv-cpanel-first-response-summary`;
    }

    spvCpanelAgentsPerforma = () => {
        return this.getApiUrl() + `monitoring/spv-cpanel-agents-performa`;
    }

    saveAgentsPerforma = () => {
        return this.getApiUrl() + `monitoring/spv-cpanel-save-performa`;
    }

    spvCpanelSummaryAlasanTidakClosingAllAgents = () => {
        return this.getApiUrl() + `monitoring/spv-cpanel-summary-alasan-tidak-closing-semua-agent`;
    }

    spvCpanelSummaryLeadsTemperatureAllAgents = () => {
        return this.getApiUrl() + `monitoring/spv-cpanel-summary-leads-temperature-semua-agent`;
    }

    contactListByNumbers = () => {
        return this.getApiUrl() + `contact/list-by-numbers`;
    }

    companyLastOrderDocuments = (phoneNumber) => {
        return this.getApiUrl() + `monitoring/company-last-order-documents/${phoneNumber}`;
    }


    // ******* MIGRATED TO NEW API (BE-EXPRESS) *******

    messagesList() {
        return this.getApiUrlNew() + "messages-list";
    }

    messageTemplate() {
        return this.getApiUrlNew() + "get-message-template";
    }

    getWaMessageTemplates() {
        return this.getApiUrlNew() + "wa-message-template";
    }

    markAsread() {
        return this.getApiUrlNew() + "mark-as-read";
    }

    resetUnreadCounter() {
        return this.getApiUrlNew() + "reset-unread-counter";
    }

    sendMessage() {
        // return this.getApiUrl() + "send-message";
        return this.getApiUrlNew() + "send-message";
    }

    sendMultimediaMessage() {
        return this.getApiUrlNew() + "send-multimedia-message";
    }

    sendMessageTemplate() {
        return this.getApiUrlNew() + "send-message-template";
    }

    uploadFile() {
        return this.getApiUrlNew() + "upload";
    }

    listAppProfile() {
        return this.getApiUrlNew() + "list-app-profile";
    }

    saveAppProfile() {
        return this.getApiUrlNew() + "save-app-profile";
    }

    getContactInfo() {
        return this.getApiUrlNew() + "contact-info";
    }

    saveHasilFu() {
        return this.getApiUrlNew() + "save-hasil-fu";
    }

    getDataPendingFuToday() {
        return this.getApiUrlNew() + "data-pending-fu-today";
    }

    getDataPendingFuNext() {
        return this.getApiUrlNew() + "data-pending-fu-next";
    }

    contactList() {
        return this.getApiUrlNew() + "contact-list";
        // return this.getApiUrl() + "test/contact-list";
    }

    getContactLeads() {
        return this.getApiUrlNew() + "contact-leads-report";
    }

    assignContactToUser() {
        return this.getApiUrlNew() + "assign-contact-to-user";
    }

    bulkAssignContactToUser() {
        return this.getApiUrlNew() + "bulk-assign-contact-to-user";
    }

    getParentlessContact() {
        return this.getApiUrlNew() + "parentless-contact-list";
    }

    getAssignedContact() {
        return this.getApiUrlNew() + "assigned-contact-list";
    }

    getSalesTeleUserList() {
        return this.getApiUrlNew() + "sales-tele-user-list";
    }

    allUserList() {
        return this.getApiUrlNew() + "all-user-list";
    }

    saveContactManager() {
        return this.getApiUrlNew() + "save-contact-manager";
    }

    getContactManager() {
        return this.getApiUrlNew() + "get-contact-manager";
    }

    saveHsmTemplate = () => {
        return this.getApiUrlNew() + "wa-save-message-template";
    }

    getSalesChatList() {
        return this.getApiUrlNew() + "get-sales-chat-list";
    }

    getMyCustomerToday() {
        return this.getApiUrlNew() + "get-todays-contacts";
    }

    deleteSales() {
        return this.getApiUrlNew() + "delete-sales";
    }

    addContact() {
        return this.getApiUrlNew() + "add-contact";
    }

    contactListPagedSearchable() {
        return this.getApiUrlNew() + "contact-list-paged-searchable";
    }

    login() {
        return this.getApiUrl() + "login";
    }

    supplierListPagedSearchable() {
        return this.getApiUrlNew() + "supplier-list-paged-searchable";
    }

    lavengerUsersList() {
        return this.getApiUrlNew() + "lavenger-users";
    }

    saveChatUserIds() {
        return this.getApiUrlNew() + "save-chat-user-ids";
    }

    salesResponseTimeReport() {
        return this.getApiUrlNew() + "sales-response-time-reports";
    }

    setCsHelp() {
        return this.getApiUrlNew() + "set-cs-help";
    }

    csHelpList() {
        return this.getApiUrlNew() + "cs-help-list";
    }

    csHelpUnsolvedCount() {
        return this.getApiUrlNew() + "cs-help-unsolved-count";
    }

    csSaveNote() {
        return this.getApiUrlNew() + "cs-save-note";
    }

    checkSupplierAvailability() {
        return this.getApiUrlNew() + "check-supplier-availability";
    }

    releaseSupplier() {
        return this.getApiUrlNew() + "release-supplier";
    }

    setContactLabel() {
        return this.getApiUrlNew() + "set-contact-label";
    }

    getHandoverLists() {
        return this.getApiUrlNew() + "handover-lists";
    }

    bulkAssignContactToUserAuto() {
        return this.getApiUrlNew() + "bulk-assign-contact-to-user-auto";
    }

    saveAnalisa() {
        return this.getApiUrlNew() + "save-analisa";
    }

    getListSlowResponseMessage() {
        return this.getApiUrlNew() + "list-slow-response-message";
    }

    getContactByNumber() {
        return this.getApiUrlNew() + "get-contact-by-number";
    }

    getListUnfinishedChat() {
        return this.getApiUrlNew() + "list-unfinished-chat";
    }

    getDataPendingList() {
        return this.getApiUrlNew() + "data-pending-list";
    }

    getAiModelsList() {
        return this.getApiUrlNew() + "ai/models";
    }

    aiPolishMessage() {
        return this.getApiUrlNew() + "ai/polish-message";
    }

    aiGenerateSuggestion() {
        return this.getApiUrlNew() + "ai/generate-suggestion";
    }

    aiCompass() {
        return this.getApiUrlNew() + "ai/compass";
    }

    leadByReferralSosmed() {
        return this.getApiUrlNew() + "tiktok-ads/report";
    }



}

const instance = new Api();
Object.freeze(instance);

export default instance;
